import { createFileRoute } from '@tanstack/react-router';

import { useTitle } from '../../../../hooks/useTitle';

export const Route = createFileRoute('/app/games/$game/')({
  component: GameHubPage,
});

function GameHubPage() {
  const { game } = Route.useParams();
  useTitle(game.charAt(0).toUpperCase() + game.slice(1));

  return (
    <div>
      <h1>Competitive Hub: {game}</h1>
    </div>
  );
}
